export const getDataTest = (props: any, suffix?: string): string | undefined =>
    'data-test' in props && props['data-test'] ? `${props['data-test']}${suffix || ''}` : undefined;
